import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import Animated from 'react-native-reanimated';
import { rem } from 'design-system';
import useColors from 'hooks/useColors';
const WIDTH = rem(7);
const ChartPointer = ({ height, style, contextValue }) => {
    const { dotStyle } = contextValue;
    const colors = useColors();
    const finalHeight = height - 8; // no rem required here
    return (<Animated.View pointerEvents="none" style={[styles.container, style, dotStyle]}>
      <Svg width={WIDTH} height={finalHeight} viewBox={`0 0 ${WIDTH} ${finalHeight}`} preserveAspectRatio="none">
        <Path strokeWidth={1} d={`M4 0 l0 ${finalHeight}`} stroke={colors.elements.secondary}/>
      </Svg>
    </Animated.View>);
};
export default memo(ChartPointer);
const styles = StyleSheet.create({
    container: {
        top: 4, // no rem required here
        bottom: 4, // no rem required here
        width: rem(8),
        left: -rem(4),
        position: 'absolute',
    },
});
